// extracted by mini-css-extract-plugin
export default {"section":"Questions_section__wUvIH","container":"Questions_container__Qt4S6","title":"Questions_title__vY6wQ","description":"Questions_description__o+cMP"};